<ion-header class="team-modal-header ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title class="ion-text-center">My Team</ion-title>

  </ion-toolbar>
</ion-header>

<ion-content >
  <ion-list class="team-list" lines="full">
    @for ( t of teams; track t) {
      <ion-item
        [detail]="false"
        (click)="pick(t)"
        class="team-item"
        >
      <ion-avatar slot="start">
        @if (t.logo){
          <img [src]="t.logo" [alt]="t.name" />
        }
      </ion-avatar>

      <ion-label>{{ t.name }}</ion-label>
      </ion-item>
    }
  </ion-list>
</ion-content>
